<evc-nav-button type="cta" size="xxl" variant="round" *callToAction hidden> </evc-nav-button>
<div class="title-menu-area" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start end"></div>
<mat-dialog-content>
  <div class="container" fxLayout="column">
    <div class="settings-title-container">
      <h1 [innerHTML]="getMarkPageTitle()"></h1>
    </div>

    <mat-table #table [dataSource]="markListDataSource">
      <!-- Mark Column -->
      <ng-container matColumnDef="mark">
        <mat-header-cell *matHeaderCellDef>{{ "settingTenant.configuration_LabelOfMark" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mark-cell">
          <ng-container *ngIf="row.identifier >= 0">
            {{ "settingTenant.value_" + row.code.toLowerCase() | translate }}
          </ng-container>
        </mat-cell>
      </ng-container>

      <!-- Label Column -->
      <ng-container matColumnDef="label">
        <mat-header-cell *matHeaderCellDef>{{ "settingsMarksEditDialog.label" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div *ngIf="row.identifier >= 0" class="label-form" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="10px">
            <mat-form-field appearance="outline">
              <input
                matInput
                [id]="idPrefix + row.identifier"
                [value]="row.label"
                [(ngModel)]="row.label"
                maxlength="25"
                (blur)="submit()"
                [disabled]="isMarkDisabled(row.color)"
              />
              <mat-hint class="hint-error" align="start" *ngIf="!isMarkDisabled(row.color) && requiredLabel(row.label)">
                <span class="mark-error">{{ "settingsMarksEditDialog.labelError" | translate }}</span>
              </mat-hint>
              <mat-hint
                class="hint-error"
                align="center"
                *ngIf="!isMarkDisabled(row.color) && row.label?.length > 0 && isRegularTextPattern(row.label)"
              >
                <span class="mark-error">{{ "settingsMarksEditDialog.labelMessage" | translate }}</span>
              </mat-hint>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Color Column -->
      <ng-container matColumnDef="color">
        <mat-header-cell *matHeaderCellDef>{{ "settingsMarksEditDialog.color" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index">
          <ng-container *ngIf="row.identifier >= 0">
            <mat-form-field appearance="outline">
              <mat-select hideSingleSelectionIndicator [(value)]="row.color" (selectionChange)="submit()" [disabled]="isMarkDisabled(row.color)">
                <mat-select-trigger>
                  <mat-icon class="mark-icon" [style.color]="row.color">lens</mat-icon>
                  {{ "settingsMarksEditDialog.color_" + getColorNameByTagColor(row.color)?.toLowerCase() | translate }}
                </mat-select-trigger>
                <ng-container *ngFor="let item of markItems">
                  <mat-option [value]="item.color" [disabled]="!isColorAvailable(item)" *ngIf="item.color !== disabledColorValue">
                    <mat-icon class="mark-icon" [style.color]="item.color">lens</mat-icon>
                    {{ "settingsMarksEditDialog.color_" + item.name?.toLowerCase() | translate }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-hint class="hint-error" align="center" *ngIf="row.color === ''">
                <span class="mark-error">{{ "settingsMarksEditDialog.colorMessage" | translate }}</span>
              </mat-hint>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>
      <!-- Warning Column -->
      <ng-container matColumnDef="warning">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <label class="switch">
            <input
              type="checkbox"
              (change)="toggleMark(row.identifier)"
              [checked]="!isMarkDisabled(row.color)"
              [disabled]="isOnPremise && onlineOnlyMarks.includes(row.code)"
            />
            <span class="slider round"></span>
          </label>
          <div class="warning-container">
            <label class="iplex-warning" *ngIf="onlineOnlyMarks.includes(row.code)">
              <evc-svg-icon size="md" icon="circle-info" class="blue-icon"></evc-svg-icon>
              <p class="warning-text">{{ "settingsMarksEditDialog.warning" | translate }}</p>
            </label>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedMarkColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedMarkColumns"></mat-row>
    </mat-table>
  </div>
</mat-dialog-content>
